// extracted by mini-css-extract-plugin
export var section = "mobile-frame-video-module--section--1cxUR";
export var frameWrapper = "mobile-frame-video-module--frameWrapper--3GuCT";
export var frameImg = "mobile-frame-video-module--frameImg--3S5vP";
export var video = "mobile-frame-video-module--video--1c5Q_";